module.exports = __webpack_public_path__ + "img/green.de1c5c06.png";